<template>
  <b-row align-h="center">
    <b-col cols="12" sm="8" md="6" xl="4">
      <b-form @submit.prevent="onSubmit">
        <b-form-group label="Email address:" label-for="emailInput">
          <b-form-input
            id="emailInput"
            v-model="login.email"
            type="email"
            required
            placeholder="Enter email"
          />
        </b-form-group>
        <b-form-group label="Password:" label-for="passwordInput">
          <b-form-input
            id="passwordInput"
            v-model="login.password"
            type="password"
            required
            placeholder="Enter password"
          />
        </b-form-group>
        <b-button :disabled="submited" type="submit" variant="primary"
          >Log In
        </b-button>
      </b-form>

      <b-alert
        v-for="(error, index) in errors"
        :key="index"
        show
        variant="danger"
        class="mt-3"
      >
        {{ error.msg }}
      </b-alert>
    </b-col>
  </b-row>
</template>

<script>
import API from '@/api';

export default {
  name: 'LogIn',
  data() {
    return {
      login: {
        email: '',
        password: '',
        format: 'JSON'
      },
      errors: [],
      submited: false
    };
  },
  created() {
    this.$store.commit('setCurrentUser');
  },
  methods: {
    onSubmit() {
      this.submited = true;
      API.post('admin/login', this.login).then(res => {
        this.submited = false;

        if (res.status === 'ok') {
          this.$store.commit('setCurrentUser', res.data.user);
          this.$router.push({
            path: this.$route.query.next ? this.$route.query.next : '/'
          });
        } else {
          this.errors = res.errors;
        }
      });
    }
  }
};
</script>

<style scoped></style>
